/**
 * SofaIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SofaIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M17 4.1A3.9 3.9 0 0 1 20.9 8v1.136a2.4 2.4 0 0 1 2 2.364V16a2.9 2.9 0 0 1-2.9 2.9h-.1V20a.9.9 0 0 1-1.8 0v-1.1H5.9V20a.9.9 0 0 1-1.8 0v-1.1H4A2.9 2.9 0 0 1 1.1 16v-4.5a2.4 2.4 0 0 1 2-2.364V8A3.9 3.9 0 0 1 7 4.1zM3.5 10.9a.6.6 0 0 0-.6.6V16A1.1 1.1 0 0 0 4 17.1h16a1.1 1.1 0 0 0 1.1-1.1v-4.5a.6.6 0 0 0-.6-.6h-1a.6.6 0 0 0-.6.6V14a.9.9 0 0 1-.9.9H6a.9.9 0 0 1-.9-.9v-2.5a.6.6 0 0 0-.6-.6zm3.5-5A2.1 2.1 0 0 0 4.9 8v1.136a2.4 2.4 0 0 1 2 2.364v1.6h10.2v-1.6a2.4 2.4 0 0 1 2-2.364V8A2.1 2.1 0 0 0 17 5.9z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SofaIcon = makeIcon('SofaIcon', SofaIconSvg)
